import { render, staticRenderFns } from "./5.vue?vue&type=template&id=2adcb449&scoped=true&"
import script from "./5.vue?vue&type=script&lang=js&"
export * from "./5.vue?vue&type=script&lang=js&"
import style0 from "./5.vue?vue&type=style&index=0&id=2adcb449&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adcb449",
  null
  
)

export default component.exports